import { useSelector } from "react-redux";
import { selectUser } from "redux/slices/userSlice";
import K from "utilities/constants";
import {
  isPermissionPresent,
  noTrailingSpaceAllowedRule,
} from "utilities/generalUtility";
import { useCandidateFieldEdit } from "./useCandidateFieldEdit";

export const useCandidateSectionContext = (
  candidateJobEntry,
  setCandidateJobEntry,
  onCandidateChanged,
  isAssignedToJob,
) => {
  const userRoles = useSelector(selectUser).roles;
  const canEdit =
    candidateJobEntry.isConsiderable !== 0 &&
    isPermissionPresent(K.Permissions.EditCandidate, userRoles) &&
    !!isAssignedToJob;
  const handleEdit = useCandidateFieldEdit(
    candidateJobEntry,
    setCandidateJobEntry,
    onCandidateChanged,
  );

  const noTrailingSpaceRule = noTrailingSpaceAllowedRule();
  const noEdgeSpacesPattern = new RegExp(noTrailingSpaceRule.pattern.source);

  const baseContext = {
    data: candidateJobEntry,
    canEdit,
    handleEdit,
    disabled: candidateJobEntry.isConsiderable === 0 || !isAssignedToJob,
    validators: {
      validateNoEdgeSpaces: (rawValue) => {
        if (rawValue == null || rawValue === "") return null;
        return noEdgeSpacesPattern.test(rawValue)
          ? null
          : noTrailingSpaceRule.message;
      },
    },
  };

  return { canEdit, handleEdit, baseContext };
};
